// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fctl-subnav_panel .pf-v6-c-panel__main-body {
  padding-block-start: 0.5rem;
  padding-block-end: 0;
}

.fctl-subnav_toolbar {
  justify-content: flex-end;
  align-items: center;
}

/* Align single-org label vertically within the toolbar */
.fctl-subnav_organization {
  align-self: center;
}
`, "",{"version":3,"sources":["webpack://./../../libs/ui-components/src/components/common/PageNavigation.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,yDAAyD;AACzD;EACE,kBAAkB;AACpB","sourcesContent":[".fctl-subnav_panel .pf-v6-c-panel__main-body {\n  padding-block-start: 0.5rem;\n  padding-block-end: 0;\n}\n\n.fctl-subnav_toolbar {\n  justify-content: flex-end;\n  align-items: center;\n}\n\n/* Align single-org label vertically within the toolbar */\n.fctl-subnav_organization {\n  align-self: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
